// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.barlow-thin {
  font-family: "Barlow", sans-serif;
  font-weight: 100;
  font-style: normal;
}

.barlow-extralight {
  font-family: "Barlow", sans-serif;
  font-weight: 200;
  font-style: normal;
}

.barlow-light {
  font-family: "Barlow", sans-serif;
  font-weight: 300;
  font-style: normal;
}

.barlow-regular {
  font-family: "Barlow", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.barlow-medium {
  font-family: "Barlow", sans-serif;
  font-weight: 500;
  font-style: normal;
}

.barlow-semibold {
  font-family: "Barlow", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.barlow-bold {
  font-family: "Barlow", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.barlow-extrabold {
  font-family: "Barlow", sans-serif;
  font-weight: 800;
  font-style: normal;
}

.barlow-black {
  font-family: "Barlow", sans-serif;
  font-weight: 900;
  font-style: normal;
}

.barlow-thin-italic {
  font-family: "Barlow", sans-serif;
  font-weight: 100;
  font-style: italic;
}

.barlow-extralight-italic {
  font-family: "Barlow", sans-serif;
  font-weight: 200;
  font-style: italic;
}

.barlow-light-italic {
  font-family: "Barlow", sans-serif;
  font-weight: 300;
  font-style: italic;
}

.barlow-regular-italic {
  font-family: "Barlow", sans-serif;
  font-weight: 400;
  font-style: italic;
}

.barlow-medium-italic {
  font-family: "Barlow", sans-serif;
  font-weight: 500;
  font-style: italic;
}

.barlow-semibold-italic {
  font-family: "Barlow", sans-serif;
  font-weight: 600;
  font-style: italic;
}

.barlow-bold-italic {
  font-family: "Barlow", sans-serif;
  font-weight: 700;
  font-style: italic;
}

.barlow-extrabold-italic {
  font-family: "Barlow", sans-serif;
  font-weight: 800;
  font-style: italic;
}

.barlow-black-italic {
  font-family: "Barlow", sans-serif;
  font-weight: 900;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/Fontstyles.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".barlow-thin {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 100;\n  font-style: normal;\n}\n\n.barlow-extralight {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 200;\n  font-style: normal;\n}\n\n.barlow-light {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 300;\n  font-style: normal;\n}\n\n.barlow-regular {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.barlow-medium {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 500;\n  font-style: normal;\n}\n\n.barlow-semibold {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.barlow-bold {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 700;\n  font-style: normal;\n}\n\n.barlow-extrabold {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 800;\n  font-style: normal;\n}\n\n.barlow-black {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 900;\n  font-style: normal;\n}\n\n.barlow-thin-italic {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 100;\n  font-style: italic;\n}\n\n.barlow-extralight-italic {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 200;\n  font-style: italic;\n}\n\n.barlow-light-italic {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 300;\n  font-style: italic;\n}\n\n.barlow-regular-italic {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 400;\n  font-style: italic;\n}\n\n.barlow-medium-italic {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 500;\n  font-style: italic;\n}\n\n.barlow-semibold-italic {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 600;\n  font-style: italic;\n}\n\n.barlow-bold-italic {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 700;\n  font-style: italic;\n}\n\n.barlow-extrabold-italic {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 800;\n  font-style: italic;\n}\n\n.barlow-black-italic {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: 900;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
